import React, { useEffect, useState } from "react";

interface CardTitleProps {
  card: { title: string };
  index: number;
}

const CardTitle: React.FC<CardTitleProps> = ({ card, index }) => {
  const [isTablet, setIsTablet] = useState(false);

  useEffect(() => {
    const checkTablet = () => {
      const ua = navigator.userAgent || navigator.vendor || "";

      // Detect iPads (all versions, iPadOS >=13 too)
      const isIpad =
        /iPad/.test(ua) || (/Macintosh/.test(ua) && "ontouchend" in document);

      // Detect Android tablets: has "Android" but NOT "Mobile"
      const isAndroidTablet = /Android/.test(ua) && !/Mobile/.test(ua);

      // Width-based fallback (generic tablets between 768px–1366px)
      const width = window.innerWidth;
      const isGenericTablet = width >= 768 && width <= 1366;

      setIsTablet(isIpad || isAndroidTablet || isGenericTablet);
    };

    checkTablet();
    window.addEventListener("resize", checkTablet);

    return () => window.removeEventListener("resize", checkTablet);
  }, []);

  // Hide completely if any tablet detected
  if (isTablet) return null;

  return (
    <p
      className={`${
        index % 2 === 1 ? "text-green-500" : "text-blue-500"
      } text-heading-6 leading-relaxed line-clamp-1 
        hidden 
        xl:block 
        xl:group-hover:hidden
      `}
    >
      {card?.title}
    </p>
  );
};

export default CardTitle;
